import React from 'react'
import useBoardPermission from './useBoardPermission'
import { BoardPermissionProps } from './types'

const withBoardPermission = <WrappedProps extends BoardPermissionProps>(
  WrappedComponent: React.ComponentType<WrappedProps>
) => {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component'

  const WithBoardPermission = React.forwardRef<typeof WrappedComponent, Omit<WrappedProps, keyof BoardPermissionProps>>((props, ref) => {
    const permission = useBoardPermission()

    return (
      <WrappedComponent
        {...props as WrappedProps}
        ref={ref}
        permission={permission}
      />
    )
  })

  WithBoardPermission.displayName = `withBoardPermission(${displayName})`

  return WithBoardPermission
}

export default withBoardPermission

